import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const FulfillmentProvidersBasicInfoComponent = ({ id, fullfillmentMethods, stores, onInnerFormChange, selectFulfillmentProvider, warehouses }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="Phone"
            name="Phone"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Login.Phone',
                selectFulfillmentProvider?.Login
              )
            }}
            type="number"
            value={selectFulfillmentProvider?.Login?.Phone}
          />
          <InputContainer
            label="Email"
            name="Email"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Login.Email',
                selectFulfillmentProvider?.Login
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.Login?.Email}
          />
          {id === '0' && (
            <InputContainer
              icon
              label="Password"
              name="Password"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.Password',
                  selectFulfillmentProvider?.Login
                )
              }}
              type="password"
              value={selectFulfillmentProvider?.Login?.Password}
            />)}
          {id === '0' && (
            <InputContainer
              icon
              label="Confirm Password"
              name="ConfirmPassword"
              onValueChange={(event: any) => {
                onInnerFormChange(
                  event.target.value,
                  'Login.ConfirmPassword',
                  selectFulfillmentProvider?.Login
                )
              }}
              type="password"
              value={selectFulfillmentProvider?.Login?.ConfirmPassword}
            />)}
        </div>
      }
      expandedPanel="LoginInfo"
      headerTitle="Login Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="FirstName"
            name="FirstName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'UserProfile.FirstName',
                selectFulfillmentProvider?.UserProfile
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.UserProfile?.FirstName}
          />
          <InputContainer
            label="Last Name"
            name="LastName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'UserProfile.LastName',
                selectFulfillmentProvider?.UserProfile
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.UserProfile?.LastName}
          />
          <InputContainer
            label="PersonTitle"
            name="PersonTitle"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'UserProfile.PersonTitle',
                selectFulfillmentProvider?.UserProfile
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.UserProfile?.PersonTitle}
          />

        </div>
      }
      expandedPanel="UserProfileInfo"
      headerTitle="UserProfile Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="PersonAccount"
            name="IsPersonAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsPersonAccount',
                selectFulfillmentProvider?.Account
              )
            }}
            type="checkbox"
            value={selectFulfillmentProvider?.Account?.IsPersonAccount}
          />
          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.Name',
                selectFulfillmentProvider?.Account
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.Account?.Name}
          />
          <InputContainer
            label="Number Of Employees"
            name="NumberOfEmployees"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.NumberOfEmployees',
                selectFulfillmentProvider?.Account
              )
            }}
            type="number"
            value={selectFulfillmentProvider?.Account?.NumberOfEmployees}
          />
          <InputContainer
            label="DisplayOrder"
            name="DisplayOrder"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.DisplayOrder',
                selectFulfillmentProvider?.Account
              )
            }}
            type="number"
            value={selectFulfillmentProvider?.Account?.DisplayOrder}
          />
          <InputContainer
            label="InternalProvider"
            name="IsInternalProvider"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsInternalProvider',
                selectFulfillmentProvider?.Account
              )
            }}
            type="checkbox"
            value={selectFulfillmentProvider?.Account?.IsInternalProvider}
          />
          <InputContainer
            label="Active"
            name="IsActive"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsActive',
                selectFulfillmentProvider?.Account
              )
            }}
            type="checkbox"
            value={selectFulfillmentProvider?.Account?.IsActive}
          />
          <InputContainer
            label="APIKey"
            name="APIKey"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.APIKey',
                selectFulfillmentProvider?.Account
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.Account?.APIKey}
          />
          <InputContainer
            label="APISecret"
            name="APISecret"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.APISecret',
                selectFulfillmentProvider?.Account
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.Account?.APISecret}
          />
          <InputContainer
            label="UserName"
            name="UserName"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.UserName',
                selectFulfillmentProvider?.Account
              )
            }}
            type="text"
            value={selectFulfillmentProvider?.Account?.UserName}
          />
          <InputContainer
            icon
            label="Password"
            name="Password"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.Password',
                selectFulfillmentProvider?.Account
              )
            }}
            type="password"
            value={selectFulfillmentProvider?.Login?.Password}
          />
          <InputContainer
            label="Store"
            labelField="StoreInfo.StoreName"
            list={stores}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.StoreId',
                selectFulfillmentProvider?.Account
              );
            }}
            optionName='Choose Store'
            type="select"
            value={selectFulfillmentProvider?.Account?.StoreId}
            valueField="StoreInfo.Id"
          />
          <InputContainer
            label="Warehouse"
            labelField="WarehouseInfo.WarehouseName"
            list={warehouses}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.WarehouseId',
                selectFulfillmentProvider?.Account,
              );
            }}
            optionName="Choose Warehouse"
            type="select"
            value={selectFulfillmentProvider?.Account?.WarehouseId}
            valueField="WarehouseInfo.Id"
          />
          <InputContainer
            label="Fullfillment Method"
            labelField="Text"
            list={fullfillmentMethods}
            onValueChange={(event: any, newValue: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.FullfillmentMethodId',
                selectFulfillmentProvider?.Account,
              );
            }}
            optionName="Choose FullfillmentMethod"
            type="select"
            value={selectFulfillmentProvider?.Account?.FullfillmentMethodId}
            valueField="Value"
          />
        </div>
      }
      expandedPanel="AccountInfo"
      headerTitle="Account Info"
    />
  </>
)
export default FulfillmentProvidersBasicInfoComponent;
